

















import Vue from 'vue';
import * as commonValidation from '@/class/common/validation';
import ModalInputBase from '@/components/util/ModalInputBase.vue';

export default Vue.extend({
  name: 'RenameModal',
  components: { ModalInputBase },
  props: {
    title: String,
    value: String,
  },
  data() {
    return {
      editingName: '',
      errorNameFlag: false,
      errorEmojiFlag: false,
      errorNameMinFlag: false,
      errorNameEmptyFlag: false,
    };
  },
  mounted() {
    this.editingName = this.value;
  },
  methods: {
    onClickOK() {
      // if (!this.errorNameFlag && !this.errorEmojiFlag) {
      if (!this.errorNameFlag && !this.errorEmojiFlag && !this.errorNameMinFlag && !this.errorNameEmptyFlag) {
        this.$emit('ok', this.editingName);
      }
    },
    onClickCancel() {
      this.$emit('close');
    },
    onInput(value: string) {
      // console.log('length:', value.length);
      // if (value.length <= 15) {
      //   this.errorNameFlag = false;
      // } else {
      //   this.errorNameFlag = true;
      // }
      if (value.length > 15) { // 15文字以内
        this.errorNameFlag = true;
        this.errorNameMinFlag = false;
      } else if (value.length < 1) { // 1文字以上
        this.errorNameMinFlag = true;
      } else {
        this.errorNameFlag = false;
        this.errorNameMinFlag = false;
      }
      if (!commonValidation.hasEmoji(value, 'emoji')) {
        this.errorEmojiFlag = false;
      } else {
        this.errorEmojiFlag = true;
      }
      // 全角または半角のスペースのみの場合
      const reg = /^[　\s]+$/;
      if (reg.test(value)) {
        this.errorNameEmptyFlag = true;
      } else {
        this.errorNameEmptyFlag = false;
      }

      // this.editingName = value;
      this.$emit('input', this.editingName);
    },
  },
});
